import { render, staticRenderFns } from "./select-and-modify-data.vue?vue&type=template&id=5da785a9&scoped=true"
import script from "./select-and-modify-data.vue?vue&type=script&lang=js"
export * from "./select-and-modify-data.vue?vue&type=script&lang=js"
import style0 from "./select-and-modify-data.vue?vue&type=style&index=0&id=5da785a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da785a9",
  null
  
)

export default component.exports